import { ApplicationInsights } from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";
import { createBrowserHistory } from "history";
import { REACT_APP_APPINSIGHTS_CONNECTION_STRING } from "./config/environment";

const reactPlugin = new ReactPlugin();
const browserHistory = createBrowserHistory();

export const appInsights = new ApplicationInsights({
  config: {
    connectionString: `${REACT_APP_APPINSIGHTS_CONNECTION_STRING}`,
    extensions: [reactPlugin],
    extensionConfig: {
      [reactPlugin.identifier]: { history: browserHistory },
    },
    enableAutoRouteTracking: true,
  },
});

appInsights.loadAppInsights();

export { reactPlugin, browserHistory };
